import { useCallback, useState } from 'react';

import { Select, SpinnerOverlay, SubmissionButtons } from '@components/common';

import useMutateMiddlewareUpdateLogPM from '@hooks/middlewareSMO/useMutateMiddlewareUpdateLogPM';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

import { nonNullishMinutesOptions } from '@constants/timeOptions';

import styles from './StorePMFilesForm.module.scss';

interface IStorePMFilesForm {
	onClose: () => void;
	selectedMiddleware: IMiddlewareSMO | null;
}

const DEFAULT_MINUTES_VALUE = nonNullishMinutesOptions[nonNullishMinutesOptions.length - 1];

const StorePMFilesForm = ({
	onClose,
	selectedMiddleware,
}: IStorePMFilesForm) => {
	const { id } = selectedMiddleware || {};

	const { updateMiddlewareLogPM, isLoadingUpdateMiddlewareLogPM } = useMutateMiddlewareUpdateLogPM(onClose);

	const [minutes, setMinutes] = useState<TSelectOption<number>>(DEFAULT_MINUTES_VALUE);

	const handleChange = useCallback((option: TSelectOption<number> | null) => {
		if (option?.value) {
			setMinutes(option);
		}
	}, []);

	const onSubmit = useCallback(() => {
		if (id && minutes?.value) {
			updateMiddlewareLogPM({
				id: id,
				logPmFilesKeepForMinutes: minutes.value,
			});
		}
	}, [id, minutes, updateMiddlewareLogPM]);

	return (
		<div className={styles.wrapper}>
			{isLoadingUpdateMiddlewareLogPM && <SpinnerOverlay />}
			<div className={styles.timeWrapper}>
				<div className={styles.timeSection}>
					<div>Keep for</div>
					<div className={styles.timeSelect}>
						<Select
							handleChange={handleChange}
							isWithoutUseForms
							menuPlacement='top'
							name='minutes'
							options={nonNullishMinutesOptions}
							placeholder='mm'
							value={minutes}
						/>
					</div>
					<div>min</div>
				</div>
			</div>
			<div>
				Time interval for how long the PM files must be kept.
				Older files will be removed automatically.
				The files are stored on the middleware server.
				See documentation for details.
			</div>

			<SubmissionButtons
				className={styles.buttons}
				negativeHandler={onClose}
				negativeLabel='Cancel'
				positiveHandler={onSubmit}
				positiveLabel='Proceed'
			/>
		</div>
	);
};

export default StorePMFilesForm;
